// PrivacyPopup.tsx
import { useEffect, useRef, useState } from 'react'
import styles from '@components/modal/modal.module.scss'
import LxCancelButton from '@components/cancelButton/LxCancelButton'
import { useModal } from '@logic/contexts/Modal/ModalContext.tsx'
import Dialog from '@mui/material/Dialog'

const PrivacyPopup: React.FC = () => {
  const [showDetails, setShowDetails] = useState(false)
  const detailsRef = useRef<HTMLDetailsElement | null>(null)
  const titleId = 'privacy-dialog-title'
  const { hideModal } = useModal()

  useEffect(() => {
    if (detailsRef.current) setShowDetails(detailsRef.current.open)
  }, [])

  return (
    <Dialog open role='dialog' aria-labelledby='create-user-dialog-title' maxWidth='sm' fullWidth aria-label='User Info'>
      <div className={styles.dialogHeader}>
        <h3 id={titleId}>Privacy Notice</h3>
      </div>

      <div className={styles.dialogContent} aria-labelledby={titleId}>
        {!showDetails && (
          <p style={{ textAlign: 'justify', lineHeight: '24px', marginBottom: 12 }}>
            <strong></strong>
            This app contains confidential information. Use only as permitted by your organization’s policies. Misuse may violate applicable laws and policies.
          </p>
        )}

        <details ref={detailsRef} open={showDetails} onToggle={(e) => setShowDetails((e.currentTarget as HTMLDetailsElement).open)} style={{ display: 'block' }}>
          <summary style={{ display: 'inline', cursor: 'pointer', textDecoration: 'underline', fontWeight: 500 }}>{showDetails ? 'Hide details' : 'Details'}</summary>

          {showDetails && (
            <div style={{ marginTop: 12, whiteSpace: 'pre-line', textAlign: 'justify', lineHeight: '24px' }}>
              <strong>Detailed privacy notice</strong>
              <br />
              This application contains confidential information belonging to your organization and its users. Please use it responsibly and in line with your organization’s data protection and
              confidentiality policies. Some information may be subject to applicable privacy and data-protection laws, such as:
              <br />
              <br />
              <strong>United States: </strong>
              FERPA, COPPA, and state student-privacy laws (e.g., California SOPIPA/CPRA, New York Education Law § 2-d, Illinois SOPPA).
              <br />
              <strong>United Kingdom: </strong>
              UK GDPR and the Data Protection Act 2018.
              <br />
              <strong>European Union: </strong>
              GDPR and applicable Member State laws.
              <br />
              <strong>Canada: </strong>
              PIPEDA and provincial public-sector privacy laws (e.g., Ontario MFIPPA, British Columbia FIPPA, Alberta FOIP).
              <br />
              <br />
              Unauthorized access, sharing, or misuse is prohibited and may lead to disciplinary or legal consequences. If you’re unsure about your responsibilities, contact your administrator or data
              protection officer.
            </div>
          )}
        </details>
      </div>

      <div className={styles.singleAction}>
        <LxCancelButton label='Close' onCancel={hideModal} classNames='lxActionButton,lxActionButtonDefaultSize,singleAction' />
      </div>
    </Dialog>
  )
}

export default PrivacyPopup
